<div class="ipm-filter-section ">
    <div class="ipm-filter-header">
        <span class="ipm-back-section"> <i class="pi pi-angle-left" (click)="closeDialog()"></i><span>filter</span></span>
        <a (click)="clear()">Clear Filter</a>
    </div>
    <div class="ipm-filter-content">
        <div class="ipm-tab-view ipm-parent-section-custom-tab" >
            <p-tabView orientation="left" styleClass="ipm-tab-custom" [(activeIndex)]="activeTabIndex">
                <ng-container *ngFor="let filterData of filterOptionList; let i = index">
                    <ng-container *ngIf="filterData?.filter_type !== 'swipes-menu' && filterData?.filter_type !== 'swipes-menu-bpm-offer'">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <span >{{filterData?.filter_label_name}}</span>
                            </ng-template>
                            <ng-container *ngIf="filterData?.filter_type === 'multiselect' || filterData?.filter_type === 'sort_menu';  else menuList">
                                <div class="ipm-mob-filter-search" *ngIf="filterData?.filter_type === 'multiselect'">
                                    <i class="pi pi-search"></i>
                                    <input type="search" placeholder="Search…" [(ngModel)]="searchQueries[i]" [ngModelOptions]="{standalone: true}">
                                </div>
                                <ng-container *ngIf="filterData.isSingleSelect; else multiCheckList">
                                    <ng-container *ngFor="let subList of (filterData.filter_sub_list | filterListSepration : geneFilterList : filterData.ApiFilterKey : isComponentType | msFilterSearch : searchQueries[i]); let j = index">
                                        <div class="ipm-custom-checkbox ipm-single-select" [class.active]="isSingleSelected(i, subList.key)" (click)="onSingleSelectClick(i, subList)">
                                            <label>{{subList.value}}</label>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #multiCheckList>
                                    <ng-container *ngFor="let subList of (filterData.filter_sub_list | filterListSepration : geneFilterList : filterData.ApiFilterKey : isComponentType | msFilterSearch : searchQueries[i]); let j = index">

                                        <div class="ipm-custom-checkbox" >
                                            <p-checkbox name="{{filterData?.filter_type === 'sort_menu' ? 'group_'+j : 'group'}}"
                                            [value]="subList"
                                            [(ngModel)]="filterData.filter_selected_values"
                                            [inputId]="filterData?.filter_label_name+'_'+subList.key"
                                            (ngModelChange)="onchangeEventInput(i)"></p-checkbox>
                                            <label [for]="filterData?.filter_label_name+'_'+subList.key">{{subList.value}}</label>
                                        </div>
                                    </ng-container>
                                </ng-template>
                            </ng-container>
                            <ng-template #menuList>
                                <ng-container *ngIf="filterData?.filter_type !== 'swipes-menu' &&   filterData?.filter_type !== 'sort_menu' && filterData?.filter_type !== 'swipes-menu-bpm-offer'">
                                    <div class="ipm-range-input-section custom-form"
                                    [class.ipm-price-section]="filterData?.ApiFilterKey === 'price'">
                                        <div class="form-group custom-form-group">
                                            <input type="text"
                                            class="form-control ipm-optional"
                                            placeholder="Min Value"
                                            (keypress)="formService.keyPressNumber($event)"
                                            (keyup)="!formService.keyPressNumber($event) ? filterData.filter_sub_list[0].starting_range : ''"
                                            id="starting_range_{{filterData?.ApiFilterKey}}"
                                            [(ngModel)]="filterData.filter_sub_list[0].starting_range"
                                            [ngModelOptions]="{standalone: true}">
                                            <span class="ipm-icon-color" *ngIf="filterData?.ApiFilterKey === 'price'">₹</span>
                                        </div>
                                        <div class="ipm-to-text">To</div>
                                        <div class="form-group custom-form-group">
                                            <input type="text"
                                            class="form-control ipm-optional"
                                            placeholder="Max Value"
                                            (keypress)="formService.keyPressNumber($event)"
                                            (keyup)="!formService.keyPressNumber($event) ? filterData.filter_sub_list[0].starting_range : ''"
                                            id="end_range_{{filterData?.ApiFilterKey}}"
                                            [(ngModel)]="filterData.filter_sub_list[0].end_range"
                                            [ngModelOptions]="{standalone: true}">
                                            <span class="ipm-icon-color" *ngIf="filterData?.ApiFilterKey === 'price'">₹</span>
                                        </div>
                                    </div>
                                    <div class="ipm-price-type-selector" *ngIf="filterData?.ApiFilterKey === 'price'&& isComponentType !== 'magic'">
                                        <mat-radio-group
                                            class="ipm-price-type-radio-group"
                                            [ngModel]="filterData.selectedPriceType || 'wav'"
                                            (ngModelChange)="onPriceTypeChange(filterData, $event)"
                                            [ngModelOptions]="{standalone: true}">
                                            <mat-radio-button
                                                *ngFor="let opt of priceTypeOptions"
                                                class="ipm-price-type-radio"
                                                [value]="opt.key">
                                                {{opt.label}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-tabPanel>
                    </ng-container>
                </ng-container>
                <p-tabPanel *ngIf="isComponentType === 'magic'">
                    <ng-template pTemplate="header">
                        <span>Stems Eq</span>
                    </ng-template>
                    <ipm-magic-search-stem-eq
                        [horizontal]="true"
                        [stems]="mobileStems"
                        (stemsChange)="onMobileStemsChange($any($event))"
                        [eqEnabled]="mobileEqEnabled"
                        (eqEnabledChange)="onMobileEqEnabledChange($any($event))">
                    </ipm-magic-search-stem-eq>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
    <div class="ipm-button-section">
        <button class="btn ipm-button" (click)="apply()">
            Apply
        </button>
    </div>
</div>
